import { useQuery } from '@tanstack/react-query'

import type { BenchmarkCostTier } from '../../../shared/domain/contribution-model'
import { fetchPolicyCostSummary } from '../../infra/api/policy-total-cost.api'
import type { PolicyCostSummaryDto } from '../../infra/api/policy-total-cost.dto'
import { POLICY_TOTAL_COST_QUERY_KEYS } from '../../infra/react-query/policy-total-cost.query-keys'
import { mapCostSummaryToPolicyTotalCostViewModel } from '../../presentation/view-models/policy-total-cost.mappers'
import type { PolicyTotalCostVM } from '../../presentation/view-models/policy-total-cost.vm'

export function usePolicyTotalCostQuery(
  companyId: string | undefined,
  tier: BenchmarkCostTier
) {
  return useQuery<PolicyCostSummaryDto, Error, PolicyTotalCostVM>({
    queryKey: POLICY_TOTAL_COST_QUERY_KEYS.detail(companyId ?? ''),
    queryFn: () => fetchPolicyCostSummary(companyId ?? ''),
    select: (response) =>
      mapCostSummaryToPolicyTotalCostViewModel(response, tier),
    enabled: Boolean(companyId),
  })
}
